"use client";
import { motion } from "framer-motion";
import React from "react";
import { cn } from "./cn";

export const SparklesCore = ({
  id,
  background,
  minSize,
  maxSize,
  particleDensity,
  className,
  particleColor,
}) => {
  const [particles, setParticles] = React.useState([]);

  React.useEffect(() => {
    const generateParticles = () => {
      const newParticles = [];
      const density = particleDensity || 100;
      
      for (let i = 0; i < density; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * ((maxSize || 2) - (minSize || 0.5)) + (minSize || 0.5),
          duration: Math.random() * 2 + 1,
          delay: Math.random() * 2,
        });
      }
      setParticles(newParticles);
    };

    generateParticles();
  }, [minSize, maxSize, particleDensity]);

  return (
    <div
      className={cn("h-full w-full", className)}
      style={{
        background: background || "transparent",
      }}
    >
      {particles.map((particle) => (
        <motion.span
          key={particle.id}
          className="absolute rounded-full"
          style={{
            left: `${particle.x}%`,
            top: `${particle.y}%`,
            width: particle.size,
            height: particle.size,
            background: particleColor || "#FFF",
          }}
          animate={{
            opacity: [0, 1, 0],
            scale: [0, 1, 0],
          }}
          transition={{
            duration: particle.duration,
            repeat: Infinity,
            delay: particle.delay,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
};

export default SparklesCore;
